import React, { FC } from 'react';
import { InputNumber, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Form from '~/components/WizardForm';
import buildNamePath from '~/utils/buildNamePath';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import { Hint } from '~/components';
import direction from '~/utils/direction';
import { DirectionProp } from '~/types/Direction';
import { useDirection } from '~/hooks/i18nHooks';

const n = buildNamePath('companyQuestionnaire');

const ExpectedTurnoverInputs: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const dir = useDirection();

  return (
    <Container className="ExpectedTurnoverInputs" dir={dir}>
      <Typography.Title level={5} className="ExpectedTurnoverInputs-TitleWithHint">
        {t('Financial performance and projection')}
        <Hint text={t('These are the values in SAR of expected financial performance')} />
      </Typography.Title>
      <InputsGroupLayout>
        <Form.Item
          name={n(['expectedTurnover', 'expectedAveragePerTransaction'])}
          label={t('Expected average per transaction')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
        <Form.Item
          name={n(['expectedTurnover', 'expectedAveragePerMonth'])}
          label={t('Expected average per month')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
        <Form.Item
          name={n(['expectedTurnover', 'expectedSixMonthAverageCreditBalance'])}
          label={t('Expected six-month average credit balance')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
        <Form.Item
          name={n(['expectedTurnover', 'expectedSalesValueTurnoverPerYear'])}
          label={t('Expected sales value turnover per year')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
      </InputsGroupLayout>

      <Typography.Title level={5} className="ExpectedTurnoverInputs-TitleWithHint">
        {t('Expected number of transactions')}
        <Hint text={t('These are the numbers of expected turnover')} />
      </Typography.Title>
      <InputsGroupLayout>
        <Form.Item
          name={n(['expectedTurnover', 'expectedMonthlyTransactions'])}
          label={t('Expected monthly transactions')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
        <Form.Item
          name={n(['expectedTurnover', 'expectedSalesVolumeTurnoverPerYear'])}
          label={t('Expected sales volume turnover per year')}
        >
          <InputNumber max={2000000000} />
        </Form.Item>
      </InputsGroupLayout>
    </Container>
  );
};

const Container = styled.div<DirectionProp>`
  .ExpectedTurnoverInputs-TitleWithHint {
    display: flex;
    align-items: center;
    .Hint {
      ${direction.margin.left(8)};
    }
  }
  .ExpectedTurnoverInputs-TotalAmountTitle {
    margin-bottom: 16px;
  }
  .ExpectedTurnoverInputs-TotalTurnover {
    margin-bottom: 0;
  }
`;

export default ExpectedTurnoverInputs;
